/**
 * 设备二级控制器
 */

import { AssembleDeviceControl } from "../subcontrol/AssembleDeviceControl";
import { UpdateCableEndControl } from "../subcontrol/UpdateCableEndControl";
import { AssembleCableControl } from "../subcontrol/AssembleCableControl";



export const DEVICE_SUB_CONTROL = {
    // 布置设备
    ASSEMBLEDEVICE: { name: "ASSEMBLEDEVICE", needInit: true, cmd: "AssembleDeviceControl", clazz: AssembleDeviceControl },
    // 布置线缆
    ASSEMBLECABLE: { name: "ASSEMBLECABLE", needInit: true, cmd: "AssembleCableControl", clazz: AssembleCableControl },
    // 编辑线缆关系
    UPDATECABLEEND: { name: "UPDATECABLEEND", needInit: true, cmd: "UpdateCableEndControl", clazz: UpdateCableEndControl },
}